import { Dispatch } from 'react'
import { IAlertState } from '../components/alert/store/alert.types'
import {
  replacePatient,
  setNewPatient,
  setSearchImport,
  setSelectedOption,
} from '../features/patientInformation/store/patientInformation.actions'
import { PatientInformationConstants } from '../features/patientInformation/store/patientInformation.constants'
import { resetSearchState, setIsPatientDataLoading } from '../features/patientSearch/store/patientSearch.actions'

import { TFunction } from 'react-i18next'
import { SagaIterator } from 'redux-saga'
import { RouteComponentProps } from 'react-router-dom'
import { TabConstants } from '../components/tabs/Tabs.constants'
import { showAlert } from '../components/alert/store/alert.actions'
import { IPatientSearchState } from '../features/patientSearch/store/patientSearch.types'
import {
  savePatientDemographics,
  setDOB,
  setFirstName,
  setLastName,
} from '../features/patientDemographics/store/patientDemographics.actions'

export const newPtClick = (
  dispatch: Dispatch<SagaIterator>,
  showImportDataConfirmationAlert: boolean,
  t: TFunction<'translation'>,
  patientSearchState: IPatientSearchState,
  history?: RouteComponentProps['history']
) => {
  const { firstName, lastName, dOB, isSetSearchImport } = patientSearchState
  const mergePatientSearchData = () => {
    dispatch(setFirstName(firstName))
    dispatch(setLastName(lastName))
    dispatch(setDOB(dOB))
    dispatch(savePatientDemographics())
    setTimeout(() => {
      dispatch(setNewPatient(true))
      if (isSetSearchImport) {
        dispatch(setSearchImport(false))
      }
      dispatch(resetSearchState())
      dispatch(setIsPatientDataLoading(false))
    }, 500)
  }

  const replacePatientData = () => {
    dispatch(replacePatient())
    setTimeout(() => {
      mergePatientSearchData()
    }, 500)
  }
  if (showImportDataConfirmationAlert) {
    const alert: IAlertState = {
      header: '',
      message: t('patientSearch.mergeReplacePatientSearchAlert'),
      buttons: [
        {
          text: t('patientSearch.cancel'),
        },
        {
          text: t('patientSearch.merge'),
          role: 'destructive',
          handler: () => {
            dispatch(setIsPatientDataLoading(true))
            mergePatientSearchData()
            history
              ? history.push(TabConstants.PATIENT_DEMOGRAPHICS)
              : dispatch(setSelectedOption(PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION))
          },
        },
        {
          text: t('patientSearch.replace'),
          role: 'destructive',
          handler: () => {
            dispatch(setIsPatientDataLoading(true))
            replacePatientData()
            history
              ? history.push(TabConstants.PATIENT_DEMOGRAPHICS)
              : dispatch(setSelectedOption(PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION))
          },
        },
      ],
    }
    dispatch(showAlert(alert))
  } else {
    dispatch(setIsPatientDataLoading(true))
    mergePatientSearchData()
    history
      ? history.push(TabConstants.PATIENT_DEMOGRAPHICS)
      : dispatch(setSelectedOption(PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION))
  }
}
